/*
* 注意：
* 1. EventBus监听事件名统一维护在这里
* 2. 方便统一管理
*/

// 全局事件
export const LOGIN_SUCCESS = 'GlobalEvent.loginSuccess'; // 登录成功
